import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function SalesMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-white">
      <div className="bg-slate-50 border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <span className="font-semibold text-slate-700 text-xs md:text-sm">
          Bảng Tính Giá (Costing): Hộp Mỹ Phẩm Cao Cấp
        </span>
        <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-[10px] md:text-xs font-medium">
          Bản Nháp
        </span>
      </div>
      <div className="p-3 md:p-4 flex-1 overflow-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 mb-4">
          <div className="space-y-1">
            <div className="text-slate-500 text-[10px] md:text-xs">
              Khách hàng
            </div>
            <div className="font-medium text-slate-800 text-xs md:text-sm">
              Công ty Dược Phẩm X
            </div>
          </div>
          <div className="space-y-1">
            <div className="text-slate-500 text-[10px] md:text-xs">
              Số lượng
            </div>
            <div className="font-medium text-slate-800 text-xs md:text-sm">
              50,000 hộp
            </div>
          </div>
          <div className="space-y-1">
            <div className="text-slate-500 text-[10px] md:text-xs">
              Quy cách
            </div>
            <div className="font-medium text-slate-800 text-xs md:text-sm">
              Hộp nắp gài đáy khóa
            </div>
          </div>
          <div className="space-y-1">
            <div className="text-slate-500 text-[10px] md:text-xs">
              Kích thước
            </div>
            <div className="font-medium text-slate-800 text-xs md:text-sm">
              10 x 5 x 15 cm
            </div>
          </div>
        </div>
        <div className="border border-slate-200 rounded-md overflow-hidden shadow-sm">
          <table className="w-full text-left">
            <thead className="bg-slate-50 border-b border-slate-200 text-[10px] md:text-xs text-slate-500">
              <tr>
                <th className="p-1.5 md:p-2 font-medium">Hạng mục chi phí</th>
                <th className="p-1.5 md:p-2 font-medium text-right">Đơn giá</th>
                <th className="p-1.5 md:p-2 font-medium text-right">
                  Thành tiền
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 text-[10px] md:text-xs">
              <tr>
                <td className="p-1.5 md:p-2">
                  <span className="font-medium">Giấy:</span> Ivory 350gsm (Khổ
                  79x109, 1500 tờ)
                </td>
                <td className="p-1.5 md:p-2 text-right">12,500 đ</td>
                <td className="p-1.5 md:p-2 text-right font-medium">
                  18,750,000 đ
                </td>
              </tr>
              <tr>
                <td className="p-1.5 md:p-2">
                  <span className="font-medium">In:</span> Offset 4 màu (2 lượt
                  in)
                </td>
                <td className="p-1.5 md:p-2 text-right">800 đ/lượt</td>
                <td className="p-1.5 md:p-2 text-right font-medium">
                  1,600,000 đ
                </td>
              </tr>
              <tr>
                <td className="p-1.5 md:p-2">
                  <span className="font-medium">Gia công:</span> Bế, dán tự
                  động, ép kim logo
                </td>
                <td className="p-1.5 md:p-2 text-right">1,200 đ/hộp</td>
                <td className="p-1.5 md:p-2 text-right font-medium">
                  60,000,000 đ
                </td>
              </tr>
              <tr className="bg-indigo-50 font-semibold text-indigo-900 border-t border-indigo-200">
                <td className="p-1.5 md:p-2">TỔNG CỘNG (Chưa VAT)</td>
                <td className="p-1.5 md:p-2 text-right text-xs md:text-sm text-slate-500 line-through">
                  85,350,000 đ
                </td>
                <td className="p-1.5 md:p-2 text-right text-sm md:text-base">
                  80,350,000 đ
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-50">
      <div className="bg-indigo-600 text-white p-3 flex flex-col items-center justify-center text-center rounded-b-xl shadow-md z-10">
        <span className="text-[10px] opacity-80 uppercase tracking-wider">
          Trình Duyệt Báo Giá
        </span>
        <span className="text-sm font-bold truncate w-full px-2">
          Hộp Mỹ Phẩm Cao Cấp
        </span>
      </div>
      <div className="flex-1 p-3 overflow-y-auto space-y-3 relative">
        <div className="bg-white p-3 rounded-xl border border-slate-200 shadow-sm">
          <div className="text-[10px] text-slate-500 mb-1">Tổng giá trị</div>
          <div className="text-lg font-bold text-indigo-700">80,350,000 đ</div>
          <div className="flex justify-between items-center mt-2 pt-2 border-t border-slate-100">
            <span className="text-[10px] text-slate-500">
              Tỷ suất LN dự kiến
            </span>
            <span className="text-xs font-bold text-green-600">22.5%</span>
          </div>
        </div>

        <div className="space-y-2">
          <div className="flex justify-between items-center px-1">
            <span className="text-[10px] font-medium text-slate-700">
              Lịch sử Duyệt
            </span>
          </div>
          <div className="relative pl-4 border-l border-indigo-200 space-y-3">
            <div className="relative">
              <div className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full bg-green-500 ring-2 ring-white"></div>
              <div className="text-[10px] text-slate-500">Sales - 10:00</div>
              <div className="text-xs text-slate-800">
                Trình duyệt giá giảm 5Tr do khách VIP.
              </div>
            </div>
            <div className="relative">
              <div className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full bg-indigo-500 ring-2 ring-white animate-pulse"></div>
              <div className="text-[10px] text-slate-500">
                Giám đốc - Chờ xử lý
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white p-3 border-t border-slate-200 flex gap-2">
        <button className="flex-1 bg-red-100 text-red-700 py-2 rounded-lg text-xs font-bold transition-colors hover:bg-red-200">
          Từ chối
        </button>
        <button className="flex-1 bg-indigo-600 text-white py-2 rounded-lg text-xs font-bold shadow-md shadow-indigo-200 transition-colors hover:bg-indigo-700">
          Phê duyệt
        </button>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
